import React, { useState, useContext, useEffect } from 'react'
import './Login.css'
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom'
import { AuthContext } from './AuthContext'
import { LanguageContext, langConstant } from '../Language/LanguageContext'
import logo from '../asset/image/main-logo.png'
import { Loading, UserProfileImage } from '../Library'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faGlobeAsia } from '@fortawesome/free-solid-svg-icons'
import { isDevelopment, baseURL } from '../Network/Config'
import { setDocumentTitle } from '../AppTitle'
import { ModalContext } from '../Library/ModalContext'
import DownloadApp from '../Library/DownloadApp'
import { buildingLogin } from '../Network/Authentication';

const menuRef = React.createRef()
const menuButtonRef = React.createRef()
function Login() {
    const modal = useContext(ModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.login
    const authCx = useContext(AuthContext)
    const [isLoading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isError, setisError] = useState(false);
    const [error, setError] = useState(null);
    const [isInvalid, setIsInvalid] = useState(false)

    const [isShowLanguage, setShowLanguage] = useState(false)

    const switchLanguage = (toLang) =>{
        langCx.setLanguage(toLang)
        setShowLanguage(false)
    }

    const showModalDownloadApp = () =>{
        const langModal = langCx.lang.download_app
        modal.setHeader(langModal.download)
        modal.setDisableBackDrop(false)
        modal.setComponent(
            <DownloadApp/>
        )
        modal.setShow(true)
    }

    const ChooseBuilding = ({ buildings, user }) => {
        const userData = user.user

        const onSelectBuilding = (buildingId) => {
            setLoading(true)
            buildingLogin(buildingId, false)
            .then((res) => {
                localStorage.setItem("building_id", buildingId)
                localStorage.setItem("is_login_finish", "true")
                modal.setShow(false)
                setLoading(false)
                authCx.setAuth(true)
            })
            .catch((error) => {
                setLoading(false)
            })
        }

        const onSignout = (e) => {
            e.preventDefault()
            authCx.signout(()=>{

            })
        }

        const BuildingItem = ({ name, icon, onClick }) => {
            return(
                <div className='building-item'
                role="button"
                tabIndex="0"
                aria-pressed="false"
                onKeyDown={(e)=>{
                    if(e.key === "Enter"){
                        onClick()
                    }
                }}
                onClick={onClick}
                >
                    { icon !== null ?
                    <img src={`${baseURL}${icon}`} className="building-logo"/>
                    :
                    <div className='no-logo'>
                        <FontAwesomeIcon icon={faBuilding}/>
                    </div>
                    }
                    <div>{name}</div>
                </div>
            )
        }
        
        return(
            <div className='choose-building'>
                <div className='head'>
                    <UserProfileImage 
                    profileImagePath={userData?.profileImagePath}
                    width={60} height={60}/>
                    <div style={{ marginLeft: 13 }}>
                        <div className='name'>{userData?.firstName} {userData?.lastName}</div>
                        <div className='email'>{userData?.email}</div>
                    </div>
                </div>
                <hr/>
                <div className='title-action'>{lang.choose_building}</div>
                <Row>
                { buildings.map((item, key) => 
                    <Col sm={6} key={key}>
                        <BuildingItem 
                        name={item.buildingName}
                        icon={item.buildingLogo}
                        onClick={()=>onSelectBuilding(item.id)}
                        />
                    </Col>
                )}
                </Row>
                <div style={{ textAlign: 'center' }}>
                    {lang.difference_account} <a href='#' onClick={onSignout}>{lang.signout}</a>
                </div>
            </div>
        )
    }

    useEffect(()=>{
        setDocumentTitle("Login")
        // const clickOutside = (e) =>{
        //     if(!menuRef?.current.contains(e.target) && !menuButtonRef?.current.contains(e.target)){
        //         setShowLanguage(false)
        //     }
        // }
        // document.addEventListener('mousedown', clickOutside, false)
        // return(()=>{
        //     document.removeEventListener('mousedown', clickOutside, false)
        // })
    },[])

    const onSubmit = () =>{
        if(!username || !password){
            setIsInvalid(true)
            return
        }
        setLoading(true);
        authCx.signin(username, password,
            (res)=>{
                if(res.buildings.length > 1){
                    setLoading(false)
                    modal.setShowHeader(false)
                    modal.setDisableBackDrop(true)
                    modal.setComponent(
                        <ChooseBuilding 
                        user={res.user}
                        buildings={res.buildings}/>
                    )
                    modal.setShow(true)
                }else{
                    buildingLogin(res.buildings[0].id, false)
                    .then((response)=>{
                        localStorage.setItem('building_id', res.buildings[0].id)
                        localStorage.setItem("is_login_finish", "true")
                        authCx.setAuth(true)
                    })
                    .catch(()=>{
                        authCx.signout(()=>{})
                    })
                    
                }
            },
            (error)=>{
                setLoading(false);
                setisError(true);
                if(error !== undefined){
                    if(error.response !== undefined){
                        if(error.response.status === 401){
                            setError(lang.no_permission)
                        }else if(error.response.status === 400){
                            setError(lang.invalid)
                        }else{
                            setError(error.message)
                        }
                    }else{
                        setError(error.message)
                    }
                }else{
                    setError(error)
                }
            }
        )
    }

    return (
        <div id="login">
            { authCx.isAuth ? <Redirect to="/"/> : null }
            { isLoading ? <Loading/> : null}
            <div>
                <div className="container login-card">
                    <div className="logo-container">
                        <img src={logo} className="logo" alt="lifelink-logo" loading="lazy"/>
                    </div>
                    { isDevelopment ?
                    <div style={{textAlign: 'center', color: 'red'}}>
                        <b>Under Development</b>
                    </div>
                    : null
                    }
                    <div style={{marginTop: 20}}>
                        <Form 
                        onSubmit={(event)=>{
                            event.preventDefault()
                            onSubmit()
                        }}>
                            <Form.Control
                            placeholder={lang.email}
                            className="input-form"
                            value={username}
                            onChange={(e)=>setUsername(e.target.value)}
                            isInvalid={!username && isInvalid}
                            />
                            <Form.Control
                            placeholder={lang.password}
                            className="input-form"
                            value={password}
                            type="password"
                            onChange={(e)=>setPassword(e.target.value)}
                            isInvalid={!password && isInvalid}
                            />
                            { isError ?
                            <div className="error">
                                {error}
                            </div> : null
                            }
                            <Button 
                            type="submit"
                            className="submit-button">
                                {lang.login}
                            </Button>
                        </Form>
                        <Link 
                        to="/forgot"
                        className="link">
                            {lang.forgot}
                        </Link>
                        
                    </div>
                </div>
                <div className="container get-app-card">
                    {lang.looking}{" "}
                    <a href="#"
                    onClick={(e)=>{
                        e.preventDefault()
                        showModalDownloadApp()
                    }}>
                        {lang.get_it}
                    </a>
                </div>
                <div className="footer">
                    <div>© LifeLinkTech</div>
                    {/* <div className="lang-item">
                        <div className="button"
                        ref={menuButtonRef}
                        onClick={()=>setShowLanguage(!isShowLanguage ? true:false)}
                        >
                            <FontAwesomeIcon icon={faGlobeAsia}/>
                        </div>
                        <div className="lang-dropdown"
                        ref={menuRef}
                        style={{display: isShowLanguage ? "block": "none"}}
                        >
                            <LangItem 
                            title="English"
                            onClick={()=>switchLanguage(langConstant.EN)}/>
                            <LangItem 
                            title="ไทย"
                            onClick={()=>switchLanguage(langConstant.TH)}/>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}


function LangItem(props){
    return(
        <div className="item"
        onClick={props.onClick}
        >
            {props.title}
        </div>
    )
}

export default Login
